module.exports = __webpack_public_path__ + "img/day9.be219d27.jpeg";